import {APICore} from 'helpers/api/apiCore';
import {AuthActionTypes} from './constants';
import {errorMessageHandler} from "../../utils";

const api = new APICore();

const INIT_STATE = {
    user: api.getLoggedInUser(),
    loading: false,
};

type UserData = {
    id: number;
    email: string;
    fullname: string;
    role: string;
    token: string;
    lastLogin: string;
};

type AuthActionType = {
    type:
        | AuthActionTypes.API_RESPONSE_SUCCESS
        | AuthActionTypes.API_RESPONSE_ERROR
        | AuthActionTypes.LOGIN_USER
        | AuthActionTypes.SIGNUP_USER
        | AuthActionTypes.LOGOUT_USER
        | AuthActionTypes.CONFIRM_USER
        | AuthActionTypes.AUTH_USER
        | AuthActionTypes.RESET;
    payload: {
        actionType?: string;
        data?: UserData | {} | any;
        error?: string;
    };
};

type State = {
    user?: UserData | {};
    loading?: boolean;
    value?: boolean;
};

const Auth = (state: State = INIT_STATE, action: AuthActionType) => {
    switch (action.type) {
        case AuthActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case AuthActionTypes.LOGIN_USER: {
                    return {
                        ...state,
                        user: action.payload.data,
                        userLoggedIn: true,
                        loading: false,
                    };
                }
                case AuthActionTypes.AUTH_USER: {
                    return {
                        ...state,
                        user: action.payload.data,
                        userLoggedIn: true,
                        loading: false,
                    };
                }
                case AuthActionTypes.SIGNUP_USER: {
                    return {
                        ...state,
                        userSignUp: true,
                        loading: false,
                        email: action.payload.data?.email,
                        password: action.payload.data?.password
                    };
                }
                case AuthActionTypes.LOGOUT_USER: {
                    return {
                        user: null,
                        loading: false,
                        userLogout: true,
                    };
                }
                case AuthActionTypes.FORGOT_PASSWORD: {
                    return {
                        ...state,
                        resetPasswordSuccess: action.payload.data,
                        loading: false,
                        passwordReset: true,
                    };
                }
                case AuthActionTypes.CONFIRM_USER:
                    return {
                        ...state,
                        loading: false,
                        userConfirmed: true
                    }
                default:
                    return { ...state, loading: false };
            }
        case AuthActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case AuthActionTypes.LOGIN_USER: {
                    return {
                        ...state,
                        error: errorMessageHandler(action.payload.error),
                        userLoggedIn: false,
                        loading: false,
                    };
                }
                case AuthActionTypes.AUTH_USER: {
                    return {
                        ...state,
                        error: errorMessageHandler(action.payload.error),
                        userLoggedIn: false,
                        loading: false,
                    };
                }
                case AuthActionTypes.SIGNUP_USER: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        error: errorMessageHandler(action.payload.error),
                        userSignUp: false,
                        loading: false,
                    };
                }
                case AuthActionTypes.FORGOT_PASSWORD: {
                    return {
                        ...state,
                        error: errorMessageHandler(action.payload.error),
                        loading: false,
                        passwordReset: false,
                    };
                }
                case AuthActionTypes.CONFIRM_USER:
                    return {
                        ...state,
                        loading: false,
                        userConfirmed: false,
                        error: errorMessageHandler(action.payload.error)
                    }
                default:
                    return { ...state, loading: false };
            }
        case AuthActionTypes.LOGIN_USER:
            return { ...state, loading: true, userLoggedIn: false };
        case AuthActionTypes.SIGNUP_USER:
            return { ...state, loading: true, userSignUp: false };
        case AuthActionTypes.LOGOUT_USER:
            return { ...state, loading: true, userLogout: false };
        case AuthActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                userSignUp: false,
                userLoggedIn: false,
                passwordReset: false,
                passwordChange: false,
                resetPasswordSuccess: null,
                userConfirmed: false,
                email: null,
                password: null,
            };
        case AuthActionTypes.CONFIRM_USER:
            return {
                ...state,
                loading: true,
                userConfirmed: false
            }
        case AuthActionTypes.AUTH_USER:
            return {
                ...state,
                loading: true,
            }
        default:
            return { ...state };
    }
};

export default Auth;
